import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-restricted-login',
  templateUrl: './restricted-login.component.html',
  styleUrls: ['./restricted-login.component.scss'],
  providers: [DatePipe]
})
export class RestrictedLoginComponent implements OnInit {
  loginForm: FormGroup;
  submitted = false;
  authenticated=false;
  

  constructor(public activeModal: NgbActiveModal,private datePipe: DatePipe, private formBuilder: FormBuilder) { }
  
  ngOnInit() {
    this.loginForm = this.formBuilder.group({
      password: [null, [Validators.required]]
    });
  }


  validate(){
    let validated = false;
    this.submitted = true;
    if (this.loginForm.invalid) {
      console.log("invalid form");
      return;
    }else if(this.loginForm.valid){
      const today = new Date();
      const password =  "Pion33"+this.datePipe.transform(today, 'MMddyyyy')+"r!";

      if(this.loginForm.value.password === password){
        validated = true;
        this.activeModal.close(validated);
      }else{
        this.loginForm.get('password').setErrors({ 'incorrectPassword': true });
      }
    }
  }

  cancel(){
    this.authenticated = false;
    this.activeModal.close(this.authenticated);
  }

  goToOfficialSite() {
    window.location.href = 'https://insureshop.ph/';
  }

}
